<template>
  <div>
    <div class="login-container">
      <LogoIcon />
      <span class="title">Artist name</span>
      <div class="login-content">
        <div class="inputs">
          <div class="floating-label has-icon">
            <input
              v-model="searchInput"
              @input="handleSearchInput"
              placeholder="Search by artist name (or paste a Spotify URL)"
              type="text"
              name="spotify"
              id="spotify"
              autocomplete="off"
            />
            <label for="spotify"> Search by artist name </label>
            <div class="input-icon">
              <SpotifyIcon class="icon small" />
            </div>
          </div>
        </div>

        <div v-if="searching" class="searching">Searching...</div>

        <div v-else class="artists">
          <div
            v-for="artist in artists"
            :key="artist.id"
            class="artist"
            @click="next(artist)"
          >
            <template v-if="artist.images.length">
              <div
                class="artist-image"
                v-bind:style="{
                  backgroundImage: 'url(' + artist.images[0].url + ')',
                }"
              ></div>
            </template>
            <template v-else>
              <div class="artist-image missing"></div>
            </template>

            <div class="name">{{ artist.name }}</div>
            <div class="followers plausible-event-name=Artist+Set">
              <template v-if="artist.followers"
                >Followers:
                {{ artist.followers.total.toLocaleString() }}</template
              >
              <template v-else>Click me to continue.</template>
            </div>
          </div>
          <button
            class="button-secondary plausible-event-name=No+Spotify"
            @click="notOnSpotifyModal = true"
          >
            <span>My music isn't on Spotify</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="notOnSpotifyModal" class="modal">
      <div class="background-overlay"></div>
      <div class="modal-container">
        <div @click="closeModal" class="modal-close">
          <CloseIcon />
        </div>
        <!-- <div class="modal-content">
          <template v-if="!wheres_music_set">
            <label class="default-input">
              <span class="wheres-music">
                Why do you want an ArtistHub account?
              </span>
              <input
                v-model="wheres_music"
                placeholder="To promote my SoundCloud/YouTube"
                type="text"
                name="wheres_music"
                id="wheres_music"
                autocomplete="off"
              />
            </label>
            <button
              @click="submitWheresMusic"
              class="button-default big"
              :disabled="!wheres_music || submitting"
            >
              <span v-if="!submitting">Submit</span>
              <span v-else>Submitting...</span>
            </button>
          </template>
          <template v-else>
            <div class="thank-you">
              Thank you for applying! We'll reach out shortly via email.
            </div>
          </template>
        </div> -->
        <div class="modal-content">
          <template>
            <label class="default-input">
              <span class="wheres-music"> What's the artist's name? </span>
              <input
                v-model="artistName"
                placeholder="Artist Name"
                type="text"
                name="wheres_music"
                id="wheres_music"
                autocomplete="off"
              />
            </label>
            <button
              @click="nextName(artistName)"
              class="button-default big"
              :disabled="!artistName"
            >
              <span>Submit</span>
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

import LogoIcon from "@/components/LogoTile";
import SpotifyIcon from "../../../public/img/icons/spotify.svg";
import CloseIcon from "../../../public/img/icons/close.svg";
import {
  Q_META,
  Q_SEARCH_ARTISTS,
  M_UPDATE_SIGNUP_STEP,
  M_UPDATE_WHERES_MUSIC,
} from "@/graphql";

export default {
  name: "SignupWizardStepAddArtist",
  components: {
    LogoIcon,
    SpotifyIcon,
    CloseIcon,
  },
  data() {
    return {
      searching: false,
      searchInput: null,
      sourceLoaded: false,
      sourceLoading: false,
      artists: [],
      notOnSpotifyModal: false,
      wheres_music: "",
      submitting: false,
      wheres_music_set: false,
      artistName: "",
    };
  },
  async created() {
    this.$store.commit("signup/resetArtists");
    await this.setStep(5);
  },
  computed: {
    ...mapState("signup", ["id"]),
  },
  methods: {
    async setStep(step) {
      console.log("setStep", step, this.id);
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_UPDATE_SIGNUP_STEP,
          variables: {
            id: this.id,
            signup_step: step,
          },
        });
        console.log("setStep", result);
      } catch (e) {
        console.log(e);
      }
    },
    handleSearchInput() {
      if (!this.searchInput) {
        clearTimeout(this.timeout);
        this.searching = false;
        this.artists = [];
        return;
      }

      this.searching = true;

      if (this.searchInput.indexOf("open.spotify.com/artist") !== -1) {
        this.getSpotifyID(this.searchInput).then((spotify_id) => {
          if (spotify_id) {
            this.getMeta(spotify_id);
          } else {
            this.searching = false;
          }
        });
      } else {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.searchSpotify(), 1000);
      }
    },
    async searchSpotify() {
      console.log("Search term:", this.searchInput);
      const artists = await this.$apollo
        .query({
          query: Q_SEARCH_ARTISTS,
          variables: {
            name: this.searchInput,
          },
        })
        .then((response) => JSON.parse(response.data.search_artists.data));

      this.searching = false;
      this.artists = artists;
    },
    async getSpotifyID(spotify_link) {
      if (spotify_link.indexOf("open.spotify.com/artist") === -1) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Oops! This doesn't look like a Spotify artist link.",
        });
        return;
      }
      return spotify_link
        .split("?")[0]
        .replace("https://open.spotify.com/artist/", "")
        .replace("http://open.spotify.com/artist/", "");
    },
    async getMeta(spotify_id) {
      const metaUrl = "http://open.spotify.com/artist/" + spotify_id;
      const metadata = await this.$apollo
        .query({
          query: Q_META,
          variables: {
            url: metaUrl,
          },
        })
        .then((response) => response.data.meta.data)
        .then((response) => JSON.parse(response));

      this.searching = false;
      this.artists = [
        {
          id: spotify_id,
          name: metadata["og_title"],
          images: [{ url: metadata["og_image"] }],
        },
      ];
    },
    async next({ id: spotify_id, name, images}) {
      this.$store.commit(
        "signup/setArtists",
        [{ spotify_id, name, image: images[0].url }]
      );
      this.$emit("nextStep");
    },
    async nextName(name) {
      this.$store.commit("signup/setArtists", [{ name }]);
      this.$emit("nextStep");
    },
    async submitWheresMusic() {
      this.submitting = true;

      await this.$apollo.mutate({
        mutation: M_UPDATE_WHERES_MUSIC,
        variables: {
          id: this.id,
          wheres_music: this.wheres_music,
        },
      });

      this.wheres_music_set = true;
      this.submitting = false;
    },
    closeModal() {
      if (this.submitting) {
        return;
      } else if (this.wheres_music_set) {
        document.location = "/logout";
      } else {
        this.notOnSpotifyModal = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.artists {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 460px));
  max-height: 400px;

  .artist {
    padding: 10px;
    border: 1px solid #100e2a;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    margin-bottom: 20px auto;
    background: #100e2a;

    &:hover {
      background: #000;
      border: 1px solid $purple;
      cursor: pointer;
    }

    .artist-image {
      background-size: cover;
      float: left;
      height: 80px;
      width: 80px;
      border-radius: 50%;
      margin: 0 20px 0 10px;

      &.missing {
        background-color: #000;
        border: 1px solid #fff;

        &::before {
          content: "?";
          font-size: 30px;
          padding: 25px;
          display: block;
          line-height: 30px;
          text-align: center;
        }
      }
    }

    .name {
      font-size: 20px;
      padding-top: 15px;
    }
    .followers {
      padding-top: 10px;
    }
  }
}

.login-container {
  width: 100vw;
  height: 100%;
  /* BG/type2 */
  background: $bg-type-2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .logo-icon {
    width: 54px;
  }
  .title {
    display: block;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }
  .login-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 12px;
    margin-top: 30px;
    .inputs {
      display: grid;
      grid-template-columns: repeat(1, 460px);
      margin-bottom: 20px;
    }
    button.continue {
      margin-top: 18px;
      width: 276px;
    }
  }
}
@media (max-width: 600px) {
  .login-container {
    padding: 24px;
    .title {
      text-align: center;
    }
    .login-content {
      padding: 0;
      width: 100%;
      .inputs {
        grid-template-columns: repeat(1, 100%);
        width: 100%;
      }
      button.continue {
        width: 100%;
      }
    }
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  .modal-container {
    padding: 60px 0 0;
    width: 450px;
    z-index: 98;
    background: linear-gradient(
      241.25deg,
      rgba(41, 39, 85, 0.45) 4.4%,
      rgba(41, 39, 84, 0.85) 61.77%,
      rgba(27, 24, 66, 0.45) 119.94%
    );
    backdrop-filter: blur(23px);
    border-radius: 10px;
    .modal-close {
      cursor: pointer;
      position: absolute;
      top: 18px;
      right: 18px;
      display: flex;
      flex-direction: column;
      &:hover {
        svg {
          path {
            fill: white;
          }
        }
        .close-text {
          color: white;
        }
      }
      svg {
        width: 24px;
        path {
          fill: #8786ab;
        }
      }
    }
    .modal-content {
      display: flex;
      flex-direction: column;
      padding: 0 40px 30px;
      .wheres-music {
        margin-bottom: 10px;
        color: #ffffff;
        padding-left: 5px;
        font-size: 14px;
      }
      button {
        margin-top: 10px;
      }
      .thank-you {
        margin: 20px 0;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
  .background-overlay {
    z-index: 97;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    cursor: unset;
    /* Purple-dark */
    background: $purple-dark;
    opacity: 0.9;
    // webkit-backdrop-filter: blur(10px) !important;
    backdrop-filter: blur(10px) !important;
  }
}
</style>
